var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-leaderboard-feed-entry-badge",class:_vm.getBadgeClass()},[_vm._v("#"+_vm._s(_vm.position))])
}
var staticRenderFns = []

export { render, staticRenderFns }